import React, { useEffect, useState, useRef } from "react";
// import { inject, observer } from "mobx-react"; // eslint-disable-line
import CountUp from "react-countup";
import { AnalyticsEvent } from "../../components/elements/analytics-event";
import { Carousel } from "react-responsive-carousel";
import { OverallTherm } from "../ui";
import { ErrorMessage, Spinner, Logo } from "../elements";
import { useSearchParams } from "react-router-dom";
const axios = require("axios");

const TotalOverlay = (props) => {
  const eventTimer = useRef(0);

  const [eventName, setEventName] = useState("");
  const [overallraised, setOverallRaised] = useState(0);
  const [overallgoal, setOverallGoal] = useState(0);
  const [overallprogress, setOverallProgress] = useState(0);
  const [eventID, setEventID] = useState(0);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [queryParameters] = useSearchParams();

  useEffect(() => {
    setEventID(queryParameters.get("eventID"));
    setLoading(true);
  }, []);

  useEffect(() => {
    if (eventID) {
      getOverallTotals();

      eventTimer.current = setInterval(getOverallTotals, 10000);
    }

    return () => {
      clearInterval(eventTimer.current);
    };
  }, [eventID]);

  useEffect(() => {
    let overallpercent = Math.round(
      100 *
        (parseFloat(overallraised) /
          parseFloat(overallgoal ? overallgoal : overallraised))
    );
    setOverallProgress(overallpercent > 100 ? 100 : overallpercent);
  }, [overallraised, overallgoal]);

  const getOverallTotals = () => {
    axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
    axios
      .post(process.env.REACT_APP_EVENT_SERVICE_URI + "/getFundraiser/", {
        fundraiserID: eventID,
      })
      .then((response) => {
        setError(false);
        if (response) {
          setEventName(response.data.name);
          setOverallRaised(
            response.data.total_amount_raised
              ? response.data.total_amount_raised.value
              : 0
          );
          if (response.data.goal && response.data.goal.value > 0) {
            setOverallGoal(response.data.goal.value);
          }
        } else {
          console.log("Unsuccessful");
        }
      })
      .catch((err) => {
        console.log("ERROR from fetching totals:", err);
        setError(true);
      });
    setLoading(false);
  };

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : loading ? (
    <Spinner />
  ) : (
    <div className="total-overlay">
      {AnalyticsEvent("english", "/", "PLAY LIVE Total Overlay")}
      <div className="top-container">
        <Logo />
        <Carousel
          axis="vertical"
          showThumbs={false}
          showStatus={false}
          showIndicators={false}
          showArrows={false}
          infiniteLoop
          autoPlay
          interval={10000}
        >
          <div>
            <div className="therm-raised">
              <CountUp
                end={overallraised ? parseFloat(overallraised) : 0}
                duration={1}
                separator=","
                decimals={2}
                prefix="$"
                preserveValue={true}
                useEasing={false}
              />{" "}
              Raised
            </div>
          </div>
          <div>
            <div
              className={
                "event-name" + `${eventName.length > 25 ? " long" : ""}`
              }
            >
              {eventName}
            </div>
          </div>
        </Carousel>
      </div>
      <div className="bottom-container">
        <OverallTherm overallprogress={overallprogress} />
      </div>

      {/*
            If we return to Oauth, use this.
            !accessToken ? (
              <div>
                <OauthSender
                  authorizeUrl="https://tiltify.com/oauth/authorize"
                  clientId={process.env.REACT_APP_APP_ID}
                  redirectUri="https://localhost:3000"
                  render={({ url }) => <a href={url}>Connect to Tiltify</a>}
                />
              </div>
            ) : (
              <div>
                <button onClick={props.userStore.destroyToken()}>
                  TEMP: Disconnect from Tiltify
                </button>
              </div>
            ) //null
            */}
    </div>
  );
};

export default TotalOverlay;
